import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';

export default function SymbolInfoCapsuleHelp() {
    return (
        <IconTooltip>
            <div>
                A Symbol Info capsule shows key static data for a symbol
                <br /> <br />A Symbol Info Capsule can be configured by
                selecting a symbol from your portfolio or adding it in settings.
            </div>
        </IconTooltip>
    );
}
